module.exports = __webpack_public_path__ + "static/media/logo-grupo-aspecir.7d116ebe.png";